<template>
  <div>
    <header-title :title="title"></header-title>
    <rs-row>
      <rs-col :span="24" class="box box-r">
        <div class="grid-content bg-purple-light right">
          <rs-tabs v-model="authTab" @tab-click="handleChangeTab" type="card">
            <rs-tab-pane label="数据权限" name="shujuquanxian">
              <auth-data ref="authDatas" :userId="userId" @change="authDataChange2" />
            </rs-tab-pane>
          </rs-tabs>
        </div>
      </rs-col>
    </rs-row>

    <treeTransfer ref="tree" :isVisible="showTransfer" :treeData="leftData" :emptyText="emptyText"
      @selectionChange="selectionChange" @closePerEdit="closePerEdit" @submitEdit="submitEdit"></treeTransfer>
  </div>
</template>

<script>
import treeTransfer from "./components/treeTransfer";
import userApi from "@/api/account";
import roleBindTable from "./components/roleBindTable";
import auth from "../authCopy";
import headerTitle from "@/components/header";
import authData from "./components/authData.vue";
export default {
  components: {
    roleBindTable,
    auth,
    headerTitle,
    authData,
    treeTransfer,
  },
  data() {
    return {
      title: "账户详情",
      accountForm: {},
      form: {},
      loading: false, // 下拉框搜索加载
      readonly: true, // 只读模式和编辑模式
      // tableData: [],
      rolesTableData: [],
      rolesList: [], // 角色列表
      roleShow: false, // 添加角色flag
      userId: "",
      userCode: "",
      showAccount: false,
      // tab绑定值
      authTab: "jibenxinxi",
      selectMall: {},
      type: "auth",
      viewType: "",
      editFlag: false,
      authDataList: {},
      showTransfer: false,
      leftData: [],
      mallId: null,
      emptyText: "",
      selectType: 2,
      mallCode: "",
    };
  },
  methods: {
    // nodeCheck(e) {
    //   let arr = []
    //   arr.push(e)
    //   const result = this.collectIdsAtDepth(arr, 1, 5-e.categoryLevel); // 从深度 1 开始
    //   userApi.selectShopTreeList({
    //     mallId: this.mallId,
    //     catIds: result,
    //     userId: this.accountForm.id
    //   }).then(res => {
    //     if (res.data.code == 200) {
    //       this.leftData = res.data.data
    //       this.$refs.tree.defaultNode()
    //     }
    //   })
    // },
    // 1按业态 2按楼层
    selectionChange(e) {
      this.selectType = e;
      if (e == 1) {
        this.authDataChange();
      } else {
        this.authDataChange2();
      }
    },

    submitEdit(e) {
      let privilegeVoList = [];
      // 选中所有
      if (e.checkedKeys.length > 0 && e.halfCheckedKeys.length == 0 && e.treeDataArr[0].selectStatus) {
        privilegeVoList.push({
          dataMallCode: this.mallCode,
          dataType: 0,
          masterId: this.accountForm.id,
          operationType: 2,
          masterType: 1,
        })
      } else if (e.halfCheckedKeys.length > 0) {
        // 所有半选的，找到其所在的层级
        console.log(e, '************submitEdit****************')

        const rootChildren = e.treeDataArr[0].childList

        for (let k = 0; k < rootChildren.length; k++) {
          let halfLevel = this.findIndeterminateLevels(rootChildren[k])
          for (let r = 0; r < halfLevel.length; r++) {
            halfLevel[r] = halfLevel[r] + 1
          }
          halfLevel.push(1)

          console.log(halfLevel, '************halfLevel****************')

          // 按楼层
          if (this.selectType == 2) {
            // 租户
            if (halfLevel.includes(3)) {
              const result = this.collectSelectedIdsAtDepth([rootChildren[k]], 1, 3);
              for (let i = 0; i < result.length; i++) {
                privilegeVoList.push({
                  dataMallCode: this.mallCode,
                  dataType: 3,
                  masterId: this.accountForm.id,
                  operationType: 2,
                  masterType: 1,
                  dataShopCode: result[i].shopNo
                });
              }
            }
            // 楼层
            if (halfLevel.includes(2) && !halfLevel.includes(3)) {
              const result = this.collectSelectedNamesAtDepth([rootChildren[k]], 1, 2);
              for (let i = 0; i < result.length; i++) {
                privilegeVoList.push({
                  dataType: 2,
                  masterId: this.accountForm.id,
                  operationType: 2,
                  masterType: 1,
                  dataFloorCode: result[i].tierName,
                  dataBuildCode: result[i].pName
                });
              }
            }
            // 楼栋
            if (halfLevel.includes(1) && !halfLevel.includes(2) && !halfLevel.includes(3)) {
              const result = this.collectSelectedNamesAtDepth([rootChildren[k]], 1, 1);
              for (let i = 0; i < result.length; i++) {
                privilegeVoList.push({
                  dataType: 1,
                  masterId: this.accountForm.id,
                  operationType: 2,
                  masterType: 1,
                  dataBuildCode: result[i].tierName
                });
              }
            }
          }
          // 按业态
          if (this.selectType == 1) {
            // 租户
            if (halfLevel.includes(4)) {
              const result = this.collectSelectedIdsAtDepth([rootChildren[k]], 1, 4);
              for (let i = 0; i < result.length; i++) {
                privilegeVoList.push({
                  dataMallCode: this.mallCode,
                  dataType: 3,
                  masterId: this.accountForm.id,
                  operationType: 2,
                  masterType: 1,
                  dataShopCode: result[i].shopNo
                });
              }
            }
            // 三级业态
            if (halfLevel.includes(3) && !halfLevel.includes(4)) {
              const result = this.collectSelectedIdsAtDepth([rootChildren[k]], 1, 3);
              for (let i = 0; i < result.length; i++) {
                privilegeVoList.push({
                  dataType: 6,
                  masterId: this.accountForm.id,
                  operationType: 2,
                  masterType: 1,
                  dataCategoryCode: result[i].id
                });
              }
            }
            // 二级业态
            if (halfLevel.includes(2) && !halfLevel.includes(3) && !halfLevel.includes(4)) {
              const result = this.collectSelectedIdsAtDepth([rootChildren[k]], 1, 2);
              for (let i = 0; i < result.length; i++) {
                privilegeVoList.push({
                  dataType: 5,
                  masterId: this.accountForm.id,
                  operationType: 2,
                  masterType: 1,
                  dataCategoryCode: result[i].id
                });
              }
            }
            // 一级业态
            if (halfLevel.includes(1) && !halfLevel.includes(2) && !halfLevel.includes(3) && !halfLevel.includes(4)) {
              const result = this.collectSelectedIdsAtDepth([rootChildren[k]], 1, 1);
              for (let i = 0; i < result.length; i++) {
                privilegeVoList.push({
                  dataType: 4,
                  masterId: this.accountForm.id,
                  operationType: 2,
                  masterType: 1,
                  dataCategoryCode: result[i].id
                });
              }
            }
          }
        }
      }

      userApi.addShopPrivilege({
        dataUserCode: this.userCode,
        dataMallCode: this.mallCode,
        operationType: 0,
        type: 0,
        operationId: this.accountForm.id,
        privilegeVoList: privilegeVoList,
        mallId: this.mallId,
      }).then((res) => {
        console.log("==============增加权限==============", res);
        if (res.data.code == 200) {
          this.selectType = 2;
          this.showTransfer = false;
          this.$message.success("操作成功！");
        }
      });
    },
    // 获取节点所在层级
    findNodeLevel(node, targetId, currentLevel = 1) {
      // 如果当前节点是目标节点，返回当前层级
      if (node.id === targetId) {
        return currentLevel;
      }

      // 递归遍历子节点
      if (node.childList && node.childList.length > 0) {
        for (const child of node.childList) {
          const foundLevel = this.findNodeLevel(child, targetId, currentLevel + 1);
          if (foundLevel !== -1) {
            return foundLevel; // 找到后直接返回结果
          }
        }
      }
      // 未找到返回-1
      return -1;
    },
    // 获取指定层级选中状态节点的id
    collectSelectedIdsAtDepth(nodeList, depth, targetDepth) {
      let selectedIds = [];
      nodeList.forEach((node) => {
        if (depth === targetDepth && node.selectStatus) {
          selectedIds.push({
            id: node.id,
            shopNo: node.shopNo
          });
        }
        // 递归调用以处理子节点，深度加 1
        if (node.childList && node.childList.length > 0) {
          selectedIds = selectedIds.concat(
            this.collectSelectedIdsAtDepth(
              node.childList,
              depth + 1,
              targetDepth
            )
          );
        }
      });
      return selectedIds;
    },

    // 获取指定层级选中状态节点的信息
    collectSelectedNamesAtDepth(nodeList, depth, targetDepth, parentTierName = null) {
      let selectedNames = [];

      nodeList.forEach((node) => {
        // 如果当前层级匹配且节点被选中
        if (depth === targetDepth && node.selectStatus) {
          selectedNames.push({
            id: node.id,
            tierName: node.tierName,
            pName: parentTierName // 添加父节点名称
          });
        }

        // 递归处理子节点，传递当前节点的 tierName 作为子节点的 pName
        if (node.childList && node.childList.length > 0) {
          selectedNames = selectedNames.concat(
            this.collectSelectedNamesAtDepth(
              node.childList,
              depth + 1,
              targetDepth,
              node.tierName // 关键修改：传递当前节点的 tierName 作为子节点的父名称
            ));
        }
      })
      return selectedNames;
    },

    collectIdsAtDepth(nodeList, depth, targetDepth) {
      let ids = [];

      nodeList.forEach((node) => {
        if (depth === targetDepth) {
          ids.push(node.id);
        }
        // 递归调用以处理子节点，深度加 1
        if (node.childList && node.childList.length > 0) {
          ids = ids.concat(
            this.collectIdsAtDepth(node.childList, depth + 1, targetDepth)
          );
        }
      });
      return ids;
    },
    closePerEdit() {
      this.selectType = 2;
      this.showTransfer = false;
    },
    // 按楼层
    authDataChange2(e) {
      if (e) {
        this.mallId = e.data.relId;
        this.mallCode = e.mallCode;
      }

      this.leftData = [];
      this.showTransfer = true;
      this.emptyText = "加载中...";
      userApi
        .buildingListTree({
          mallId: this.mallId,
          userId: this.accountForm.id,
        })
        .then((res) => {
          if (res.data.code == 200) {
            var list = res.data.data;
            for (var i = 0; i < list.length; i++) {
              this.renameChildList(list[i]);
            }
            this.leftData = this.updateTree(list[0]);

            this.emptyText = "暂无数据";
          }
        });
    },

    // 按业态
    authDataChange() {
      this.leftData = [];
      this.showTransfer = true;
      this.emptyText = "加载中...";
      userApi.selectShopTreeList({
        mallId: this.mallId,
        userId: this.accountForm.id,
      }).then((res) => {
        if (res.data.code == 200) {
          var list = res.data.data;
          for (var i = 0; i < list.length; i++) {
            this.rebuildChildList(list[i]);
          }
          this.leftData = this.updateTree(list[0]);
          this.emptyText = "暂无数据";
        }
      });
    },

    updateTree(root) {
      // 第一步：从根节点开始遍历，若节点的selectStatus为1，将其所有子孙节点的selectStatus置为1
      const traverseAndSelectDescendants = (node) => {
        // 如果当前节点被选中，递归选中所有子孙节点
        if (node.selectStatus === 1) {
          const selectAllChildren = (current) => {
            if (current.childList && current.childList.length > 0) {
              for (const child of current.childList) {
                child.selectStatus = 1; // 设置子节点为选中
                selectAllChildren(child); // 递归处理更深层次的子节点
              }
            }
          };
          selectAllChildren(node);
        }

        // 继续遍历子节点
        if (node.childList && node.childList.length > 0) {
          for (const child of node.childList) {
            traverseAndSelectDescendants(child);
          }
        }
      };

      // 执行第一步遍历
      traverseAndSelectDescendants(root);

      // 第二步：遍历所有叶子节点，如果节点是叶子节点且被选中，将其所有祖先节点都选中
      const path = []; // 用于记录当前节点到根节点的路径
      const traverseLeavesAndSelectAncestors = (node) => {
        path.push(node); // 将当前节点加入路径

        // 检查是否为叶子节点
        if (!node.childList || node.childList.length === 0) {
          // 如果叶子节点被选中，设置所有祖先节点为选中
          if (node.selectStatus === 1) {
            // 遍历路径中的所有祖先节点（除了当前叶子节点自身）
            for (let i = 0; i < path.length - 1; i++) {
              path[i].selectStatus = 1;
            }
          }
        } else {
          // 非叶子节点，继续遍历子节点
          for (const child of node.childList) {
            traverseLeavesAndSelectAncestors(child);
          }
        }

        path.pop(); // 回溯，移除当前节点
      };

      // 执行第二步遍历
      traverseLeavesAndSelectAncestors(root);

      return [root];
    },


    findIndeterminateLevels(root) {
      let levels = new Set();
      const traverse = (node, currentLevel) => {
        if (node.childList && node.childList.length > 0) {
          // 检查所有直接子节点是否都被选中
          let allChildrenSelected = true;
          if (node.selectStatus) {
            for (const child of node.childList) {
              if (!child.selectStatus) {
                allChildrenSelected = false;
                break;
              }
            }
          }
          if (!allChildrenSelected) {
            console.log(node, '这个节点是半选的')
            levels.add(currentLevel);
          }
          // 递归处理子节点
          for (const child of node.childList) {
            traverse(child, currentLevel + 1);
          }
        }
      }
      traverse(root, 1);
      return Array.from(levels).sort((a, b) => a - b);
    },

    renameChildList(node) {
      node.childList = node.investMallManageTreeVo;
      node.categoryName = node.tierName;
      if (node.tierLevel == "7") {
        node.id = "iu" + node.id;
      }
      if (node.childList instanceof Array) {
        node.childList.forEach(this.renameChildList); // 递归处理子节点
      }
    },

    rebuildChildList(node) {
      if (node.categoryLevel == 4) {
        node.id = "iu" + node.id;
      }
      if (node.childList instanceof Array) {
        node.childList.forEach(this.rebuildChildList); // 递归处理子节点
      }
    },

    cencel() {
      this.$refs.authDetailData.cencel();
      this.editFlag = false;
    },
    //
    authData(val) {
      console.log(val);
      this.authDataList = val;
    },
    // 商场默认选中切换当前选中商场
    // 查询该系统下所有商场
    queryMalls() {
      let self = this;
      let userInfo = Utils.getSession("userInfo");
      let zendaiMarket = Utils.getSession("zendaiMarket")
        ? Utils.getSession("zendaiMarket")
        : userInfo.mallVo;
      Utils.setSession("zendaiMarket", zendaiMarket);
      this.mainEntSelectVal = Utils.getSession("zendaiMarket")
        ? Utils.getSession("zendaiMarket").id
        : "";
      userApi.queryHomeAuthMall(userInfo.id).then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          self.selectMall = res.data.data.find((item) => {
            return item.selected;
          });
          if (self.selectMall) {
            self.handleChangeMall(self.selectMall.id);
          }
        } else {
          Utils.setSession("zendaiMarket", null);
          userInfo.mallVo = null;
          Utils.setSession("userInfo", userInfo);
          Utils.setSession("posUserInfo", userInfo);
        }
      });
    },
    // 选择商场,针对该商场下的数据
    handleChangeMall(val) {
      let user = Utils.getSession("userInfo");
      indexApi
        .checkMarket({
          mallId: val,
          userId: user.id,
        })
        .then((res) => {
          let checkedMall = this.selectMall;
          Utils.setSession("zendaiMarket", checkedMall);
          user.mallVo = checkedMall;
          Utils.setSession("userInfo", user);
          Utils.setSession("posUserInfo", user);
        });
    },
    // 添加权限
    addUserAuth() {
      // this.readonly = true
      this.editFlag = true;
      this.$refs.authDetailData.handleMenusAndButtons(1, 0, "edit");
      // let form = {
      //     operationId: this.userId,
      //     operationType: 0,
      //     applicationPrivilegeVoList: {}
      // }
      // this.$dialogManage({
      //     width: '498px',
      //     title: '分配权限',
      //     formData: form,
      //     type: 'addUserAuth',
      //     className: 'form-dialog add-form-dialog'
      // }).then(data => {
      //     let form = data.applicationPrivilegeVoList
      //     console.log(form);
      //     this.submitAuth(form)
      // })
    },
    submitAuth(params) {
      // this.authDataList
      userApi
        .setAuth(this.authDataList)
        .then((res) => {
          this.$message.success("设置成功！");
          this.handleDetail();
          // this.$refs['authDetail'].handleAuthData()
          this.$refs.authDetailData.handleMenusAndButtons(1, 0, "view");
          this.cencel();
        })
        .catch((err) => { });
    },
    // 获取详情
    handleDetail() {
      userApi
        .getUserInfoDetail({
          id: this.userId,
        })
        .then((res) => {
          this.accountForm = res.data.data;
        });
    },
    // 获取用户数据权限
    // handleMalls() {
    //     userApi.queryMallsAuth(this.userId).then(res=>{
    //         this.tableData = res.data.data
    //     })
    // },
    handleChangeTab(tab, event) { },
    changeType(val) { },
    // 操作数据权限授权和取消授权
    handleChangeAuth(val) {
      let params = [
        {
          masterId: this.accountForm.id,
          accessId: val.id,
          accessType: 2,
        },
      ];
      if (val.empower) {
        params[0].operationType = 2;
        let form = {
          privilegeVoList: params,
          operationId: this.accountForm.id,
          operationType: 0,
        };
        userApi
          .addAuth(form)
          .then((res) => {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            // this.handleMalls()
          })
          .catch((err) => {
            // this.handleMalls()
          });
      } else {
        params[0].operationType = 3;
        userApi
          .cancelAuth(params[0])
          .then((res) => {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            // this.handleMalls()
            this.queryMalls();
          })
          .catch((err) => {
            // this.handleMalls()
          });
      }
    },
    // 提交编辑user
    editUser() {
      this.$router.push(
        `/accountManageEdit?id=${this.userId}&orgName=${this.accountForm.orgName}`
      );
    },
    /**
     * @param {type} 分配数据权限
     */
    changeAuthDate() {
      this.$refs.authDatas.changeReadonly(false);
    },
  },
  created() {
    this.userId = this.$route.query.id;
    this.userCode = this.$route.query.userCode;
    this.viewType = this.$route.params.type;
    if (this.viewType === "auth") this.authTab = "shujuquanxian";
    this.handleDetail();
    // this.handleMalls()
  },
  filters: {
    sex(item) {
      return item == 1 ? "男" : "女";
    },
    status(val) {
      return val == 1 ? "启用" : "冻结";
    },
  },
};
</script>

<style scoped>
.height100 {
  height: 100%;
}

.box {
  background: #ffffff;
  /* height: calc(100% - 19px); */
  /* padding: 10px 20px; */
}

.box-l {
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin: 4px 1.3% 15px 1.3%;
}

.box-r {
  /* margin-bottom: 15px; */
  overflow: auto;
  /* padding-bottom: 15px; */
  /* border-left: 1px solid rgba(0,0,0,0.1); */
}

.edit-button {
  display: flex;
  justify-content: flex-end;
  padding: 3px 9px;
}

/deep/.right .rs-tabs__header {
  margin-bottom: 9px;
}

.hover-style {
  font-size: 14px;
}

.rs-form-item {
  margin-bottom: 0;
}

/deep/.rs-form-item__label {
  color: #666666;
}

.right {
  position: relative;
  padding: 0 9px 0 13px;
}

.right .view-auth-button {
  position: absolute;
  top: 0;
  right: 9px;
}

.box-l .rs-form-item__content .rs-button--mini {
  padding: 3px 0;
}

/deep/.station-button-list .rs-form-item__content {
  line-height: 22px;
  margin-top: 9px;
}

/deep/.station-button-list button.rs-button.hover-style.rs-button--text.rs-button--mini {
  margin-left: 0 !important;
  margin-right: 20px !important;
}

/deep/.rs-tabs__content {
  overflow: visible;
}

.header {
  margin-bottom: 9px !important;
}

.add-role-button {
  padding: 0 !important;
  margin-bottom: 10px;
  height: 20px !important;
}

.footer {
  position: fixed;
  /* right: 5%; */
  bottom: 20px;
  width: 100%;
  height: 50px;
  border-top: 1px solid #ccc;
  background: #fff;
  display: flex;
  bottom: 0;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;
  z-index: 99;
}
</style>